import React from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { CircularProgress } from "@mui/material";
import { getButtonStyle } from "./styles/commonStyles";
import { colorPalette } from "../../utils/colorPalette";

interface GenericButtonProps {
  text: string;
  onClick?: any;
  variant: "contained" | "outlined" | "text";
  type?: "submit" | "button";
  px?: any;
  mr?: any;
  ml?: any;
  mt?: any;
  ht?: any;
  styles?: any;
  disable?: any;
  isLink?: boolean;
  fullWidth?: boolean;
  hasIcon?: boolean;
  style?: any;
  icon?: any;
  disabledVariant?: string;
  startIcon?: any;
  isLoading?: boolean;
  backgroundColor?: string;
  textColor?: string;
}

const GenericButton: React.FC<GenericButtonProps> = ({
  text,
  onClick,
  variant,
  type = "button",
  disable = false,
  isLink = false,
  fullWidth = false,
  hasIcon = false,
  icon = null,
  disabledVariant = "outlined-disabled",
  startIcon = false,
  style = {},
  isLoading = false,
  backgroundColor = colorPalette.colorPureBlack,
  textColor = colorPalette.colorOffWhite,
}) => {
  const updatedIcon =
    hasIcon && icon
      ? React.cloneElement(icon, {
          color: disable
            ? disabledVariant === "outlined-disabled"
              ? colorPalette.colorVeryDarkGray
              : colorPalette.colorPureWhite
            : icon.props.color,
        })
      : null;

  return (
    <Button
      variant={variant}
      onClick={onClick}
      disabled={disable || isLoading}
      sx={ !isLink && {
        ...getButtonStyle(variant, backgroundColor),
        opacity: isLoading ? 0.6 : 1,
        pointerEvents: isLoading ? "none" : "auto", // Ensure no interaction
      }}
      style={{ ...style }}
      fullWidth={fullWidth}
      type={type}
      {...(startIcon && !isLoading
        ? { startIcon: updatedIcon }
        : !startIcon && !isLoading
        ? { endIcon: updatedIcon }
        : {})}
    >
      <Typography
        sx={{
          fontFamily: "Inter",
          fontSize: 14,
          textTransform: "none",
          color: isLink ? colorPalette.colorAccent : textColor,
        }}
      >
        {text}
      </Typography>
      {isLoading && (
        <CircularProgress size={16} sx={{ marginLeft: 1 }} color="inherit" />
      )}
    </Button>
  );
};

export default GenericButton;
